/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import CaseReportButton from './CaseReportButton';
import { CASE_STATUSES } from '../../models/Case';
import { WorkspaceProductType } from '../../models/Workspace';

const useStyles = makeStyles((theme) => {
  return {
    link: {
      color: theme.palette.primary.main,
    },
    materialText: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontStyle: 'normal',
      fontWeight: '500',
      lineHeight: '26px',
    },
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
  };
});

const CaseActionsReportInformationSubmitted = ({ caseStatus, renderActionButtons, onViewMaterial, workspace }) => {
  const classes = useStyles();
  const videoUrl = caseStatus?.data?.videoReport?.h264?.downloadLink || caseStatus?.data?.videoReport?.downloadLink;
  const thumbnailPath = caseStatus?.data?.videoReport?.thumbnailPath;
  const { ARCHIVED, DELAYED, NEW, NOT_PAID, PENDING_IMAGES, PENDING_UPLOAD, UPLOADING } = CASE_STATUSES;
  const doNotShowReportButton = !caseStatus?.data?.caseReport && workspace?.productType === WorkspaceProductType.LawFirm.value;
  const useReadMode = workspace?.productType === WorkspaceProductType.LawFirm.value;

  return (
    <Grid container direction="column" style={{ textAlign: 'left' }} justify="space-between">
      <Grid item container direction="column">
        {caseStatus?.data?.videoReport && (
          <>
            <Grid item>
              <Typography className={classes.sectionHeader}>Video Report</Typography>
            </Grid>

            <Grid item style={{ height: '288px' }}>
              <video controls style={{ height: '100%', objectFit: 'contain', width: '100%' }} poster={thumbnailPath} preload="none">
                <source src={videoUrl} />
              </video>
            </Grid>
          </>
        )}
        {caseStatus?.data?.supplementaryMaterials?.length > 0 && (
          <>
            <Grid item>
              <Typography className={classes.sectionHeader}>Supplementary Materials</Typography>
            </Grid>
            <Grid item>
              {caseStatus?.data?.supplementaryMaterials?.map((material, index) => (
                <Typography className={classes.materialText}>
                  {index + 1} &nbsp;
                  <a className={classes.link} href="javascript:void(0)" onClick={() => onViewMaterial(material.material)}>
                    {material.material.title}
                  </a>
                </Typography>
              ))}
            </Grid>
          </>
        )}
        <div className="mt-1">{renderActionButtons()}</div>

        {![ARCHIVED, DELAYED, NEW, NOT_PAID, PENDING_IMAGES, PENDING_UPLOAD, UPLOADING].includes(caseStatus.status) && !doNotShowReportButton && (
          <CaseReportButton caseReport={caseStatus?.data?.caseReport} caseId={caseStatus?.data?.id} readMode={useReadMode} />
        )}
      </Grid>
    </Grid>
  );
};

export default CaseActionsReportInformationSubmitted;
